export default Object.freeze({
  blue: 'blue',
  yellow: 'yellow',
  red: 'red',
  green: 'green',
  purple: 'purple',
  grey: 'grey',
})
